import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography
} from "@mui/material";

import { COLORS } from "../../theme/theme";
import { RouteAccess } from "./MenuItems";

type Link = RouteAccess;

interface NavLinksGroupProps {
  label: string;
  icon?: React.ElementType;
  opened: boolean;
  onToggle: () => void;
  accessCategory: string;
  links?: Link[];
  link?: string;
  access?: string;
  category?: string;
  isActve?: boolean;
}

export const NavLinksGroup: React.FC<NavLinksGroupProps> = ({
  label,
  icon: Icon,
  opened,
  onToggle,
  links,
  link,
  access,
  category,
  isActve,
}) => {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.user.user);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const authorized = links?.some((linkItem) =>
    linkItem.canAccess(user.scope, user.category)
  );

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    onToggle();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!authorized) return null;

  const IconComponent = Icon;

  return (
    <Box sx={{ mt: 1 }}>
      <Button
        variant="text"
        onClick={handleClick}
        startIcon={IconComponent ? <IconComponent /> : null}
        sx={{
          justifyContent: "flex-start",
          width: "100%",
          borderRadius: 0,
          color: COLORS.neutral[100],
          borderBottom: isActve
            ? `2px solid rgba(255, 255, 255, 0.69)`
            : "transparent",
          textTransform: "none",
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          color={COLORS.neutral[100]}
          fontWeight={600}
        >
          {label}
        </Typography>
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {links?.map((linkItem) => {
          const authorizedItem = linkItem.canAccess(
            user.scope,
            user.category
          );

          if (!authorizedItem) return null;

          return (
            <MenuItem
              key={linkItem.label}
              onClick={() => {
                handleClose();
                navigate(linkItem.path);
              }}
            >
              {linkItem.label === "G2000" ? user.company : linkItem.label}
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
};